import React from 'react';

interface AmbientBackgroundProps {
  children: React.ReactNode;
  mood?: 'sun' | 'moon';
  className?: string;
  /** Path to a watercolor background image (served from /public) */
  backgroundImage?: string;
  /** Optional video source for hero backgrounds */
  backgroundVideo?: string;
}

const AmbientBackground: React.FC<AmbientBackgroundProps> = ({
  children,
  mood = 'sun',
  className = '',
  backgroundImage,
  backgroundVideo,
}) => {
  const sunGradient =
    'radial-gradient(ellipse at 30% 20%, rgba(212,130,10,0.1) 0%, transparent 50%), ' +
    'radial-gradient(ellipse at 70% 80%, rgba(232,160,32,0.06) 0%, transparent 50%)';

  const moonGradient =
    'radial-gradient(ellipse at 30% 20%, rgba(74,63,107,0.12) 0%, transparent 50%), ' +
    'radial-gradient(ellipse at 70% 80%, rgba(53,45,74,0.1) 0%, transparent 50%)';

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Watercolor background image */}
      {backgroundImage && (
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.35,
          }}
        />
      )}
      {/* Background video (hero only) */}
      {backgroundVideo && (
        <video
          autoPlay
          muted
          loop
          playsInline
          ref={(el) => { if (el) el.playbackRate = 0.5; }}
          className="absolute inset-0 w-full h-full object-cover pointer-events-none dark:opacity-25"
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}
      {/* Ambient gradient overlay */}
      <div
        className="absolute inset-0 animate-breathe pointer-events-none"
        style={{ background: mood === 'sun' ? sunGradient : moonGradient }}
      />
      <div className="relative z-[1]">{children}</div>
    </div>
  );
};

export default AmbientBackground;
